import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        opacity="0.4"
        d="M43.4199 29.8C36.5899 21.09 26.7799 20.9001 24.6799 21.0001C22.5799 20.9101 12.4499 20.85 5.93994 29.8C-2.24006 41.05 0.509944 65.3801 0.509944 65.3801C0.509944 65.3801 3.58994 57.34 4.70994 41.23C4.92994 38.03 7.56995 34.0001 10.4099 33.0101C14.4599 31.6001 19.7199 33.5601 24.6699 33.5601C29.2199 33.5601 34.2 31.9301 38.16 33.0101C41.53 33.9201 44.3099 37.67 44.6399 41.23C46.0899 57.12 49.0599 65.71 49.0599 65.71C49.0599 65.71 52.1499 40.94 43.4199 29.8Z"
        fill={fill}
      />
      <path
        d="M33.06 31.58C34.64 28.88 39.54 21.67 33.98 17.98C28.84 14.57 27.81 6.14996 27.81 6.14996C28.14 8.29996 26.65 11.93 26.65 11.93C27.31 7.79999 25.66 4 25.66 4C25.66 4 24.01 13.25 17.9 17.21C13.07 20.35 13.44 23.93 16.41 31.58C22.31 32.73 26.99 32.68 33.06 31.58Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M28.9701 9.12C29.0501 11.13 28.9101 13.16 28.5501 15.16C28.2001 17.16 27.64 19.13 26.77 21C26.33 21.94 25.7801 22.82 25.3001 23.65C24.8301 24.51 24.3901 25.39 24.0501 26.31C23.7101 27.22 23.42 28.17 23.28 29.14C23.12 30.11 23.1001 31.11 23.3601 32.08C22.4901 30.22 22.7401 28 23.3101 26.06C23.5801 25.06 24.0201 24.13 24.4601 23.21C24.9501 22.29 25.4701 21.47 25.8601 20.58C26.7001 18.82 27.28 16.92 27.78 15C28.27 13.07 28.6701 11.11 28.9701 9.12Z"
        fill={outline}
      />
      <path
        d="M25.34 7.95996C25.34 7.95996 25.34 15.23 22.37 20.84C19.4 26.45 17.58 28.6 18.57 31.9"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M29.8001 13.08C29.8001 13.08 29.1701 18.91 30.4601 23.65C31.9501 29.1 31.1201 32.07 31.1201 32.07"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M22.04 16.55C21.65 17.83 21.08 19.06 20.41 20.22C19.77 21.4 18.88 22.47 18.24 23.52C16.95 25.69 16.44 28.29 17.03 30.91C16.35 29.75 16.04 28.34 16.13 26.96C16.2 25.57 16.67 24.21 17.38 23.02C17.75 22.43 18.18 21.8601 18.59 21.3801L19.78 19.8201C20.55 18.7501 21.32 17.68 22.04 16.55Z"
        fill={outline}
      />
    </g>
  )
}
